import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  delete  group account
export const DeleteGroupAccount = createSlice({
  name: "DeleteGroupAccount",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    delete_DeleteGroupAccount: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_delete_DeleteGroupAccount: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_delete_DeleteGroupAccount: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    delete_DeleteGroupAccount_is_success: (state, action) => {
      state.isSuccess = false;
    },
    false_switchDeleteGroupAccount_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default DeleteGroupAccount.reducer;
export const {
  delete_DeleteGroupAccount,
  success_api_call_delete_DeleteGroupAccount,
  failure_api_call_delete_DeleteGroupAccount,
  delete_DeleteGroupAccount_is_success,
  false_switchDeleteGroupAccount_response
} = DeleteGroupAccount.actions;
